import { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Church } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;

/**
 * Small rotating quote widget for real, admin-approved church testimonials.
 * Renders nothing until at least one church-type testimonial has been approved.
 */
export const ChurchTestimonialWidget = ({ colors }) => {
  const [testimonials, setTestimonials] = useState([]);
  const [idx, setIdx] = useState(0);
  const navy = colors?.navy || '#1B2A41';
  const sage = colors?.sage || '#8A9A86';

  useEffect(() => {
    fetch(`${API}/api/testimonials/public?limit=20`)
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => {
        const church = (d?.testimonials || []).filter((t) => t.member_type === 'church');
        if (church.length) setTestimonials(church);
      })
      .catch(() => {});
  }, []);

  useEffect(() => {
    if (testimonials.length < 2) return;
    const timer = setInterval(() => setIdx((i) => (i + 1) % testimonials.length), 6000);
    return () => clearInterval(timer);
  }, [testimonials.length]);

  if (!testimonials.length) return null;
  const t = testimonials[idx];

  return (
    <div data-testid="homepage-church-testimonial-widget" style={{
      maxWidth: '640px', margin: '2.5rem auto 0', background: 'white',
      border: `1px solid ${sage}30`, borderRadius: 16, padding: '1.5rem 1.75rem', textAlign: 'left'
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.75rem', color: sage, fontSize: '0.75rem', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.04em' }}>
        <Church size={16} />
        <span>From a Partner Church</span>
      </div>
      <AnimatePresence mode="wait">
        <motion.div
          key={idx}
          initial={{ opacity: 0, y: 6 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -6 }}
          transition={{ duration: 0.4 }}
        >
          <p data-testid="homepage-church-testimonial-text" style={{ fontFamily: 'var(--font-heading)', fontStyle: 'italic', fontSize: '1rem', color: navy, lineHeight: 1.7, margin: '0 0 0.75rem' }}>
            "{t.testimonial_text}"
          </p>
          <footer style={{ fontSize: '0.85rem', color: `${navy}99` }}>
            <strong>{t.is_anonymous ? 'Anonymous' : t.member_name}</strong> · Partner Church
          </footer>
        </motion.div>
      </AnimatePresence>
    </div>
  );
};

export default ChurchTestimonialWidget;
